'use client';

import { createContext, useState } from 'react';
import { useQuery } from 'react-query';
import { useLocale } from 'next-intl';

import { getCookie, setCookie } from 'utils/cookies';
import { COOKIE_POLICY_ACCEPTED } from 'constants/constants';
import useGetWebsiteSettings from 'hooks/useGetWebsiteSettings';
import getUserLocation from 'api/location/getUserLocation';
import { QUERY_IDS } from 'api';
import { countryCodeToPhonePrefixMap } from 'constants/countryCodeToPhonePrefixMap';

const { GET_USER_LOCATION } = QUERY_IDS;

const WebsiteSettingsContext = createContext();

const WebsiteSettingsContextProvider = ({ children }) => {
  const locale = useLocale();
  const { data: userLocation } = useQuery(GET_USER_LOCATION, () => getUserLocation(), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 60 * 2,
  });

  const cookiePolicy = getCookie(COOKIE_POLICY_ACCEPTED);
  const [cookiesPolicyAccepted, setCookiesPolicyAccepted] = useState(cookiePolicy);
  const { data: websiteSettings, isLoading: isLoadingWebsiteSettings } = useGetWebsiteSettings({ language: locale });

  const setPolicyCookie = ({ name = COOKIE_POLICY_ACCEPTED, value = '' }) => {
    setCookiesPolicyAccepted(value);
    setCookie(name, value);
  };

  const isLoading = isLoadingWebsiteSettings;

  return (
    <WebsiteSettingsContext.Provider
      value={{
        isLoading,
        ...websiteSettings,
        cookiesPolicyAccepted,
        setCookiesPolicyAccepted,
        setPolicyCookie,
        userLocation: {
          ...userLocation,
          countryPhoneCode: countryCodeToPhonePrefixMap.get(userLocation?.country_code) || '+1',
        },
      }}
    >
      {children}
    </WebsiteSettingsContext.Provider>
  );
};

export { WebsiteSettingsContext };
export default WebsiteSettingsContextProvider;